// Presentation-only content for the pricing section.
// Plan id, price, max users, trial period and modules come from the API
// (`/hrx/plans`) and are matched to these entries by plan name, so changing a
// price or module in the admin panel needs no change here.

export type PricingPlanKey = "basic" | "standard" | "premium";

export interface PricingPlanContent {
  key: PricingPlanKey;
}

export const PRICING_PLANS: PricingPlanContent[] = [
  { key: "basic" },
  { key: "standard" },
  { key: "premium" },
];

// Enterprise is not a self-serve plan: it gets every module plus these.
export const ENTERPRISE_PLAN = {
  name: "Enterprise",
  extras: ["Custom Modules", "API Integration"],
};

// AI add-ons are billed per use and only offered on plans that include
// recruitment (Premium and Enterprise).
export const AI_ADDONS = [
  {
    name: "TalentHunt",
    description:
      "AI finds and ranks the best-matched candidates for your job post.",
    price: 200,
    unit: "job post",
  },
  {
    name: "AI Interview",
    description:
      "Automated AI interviews that screen and score candidates for you.",
    price: 250,
    unit: "interview",
  },
];

export const RECRUITMENT_MODULE_KEYWORD = "recruitment";
